import { useMemo } from 'react';

import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

export const useInfinityAutoplayHiddenFlag = (): boolean => {
  const EXCEPTION_JURISDICTIONS = useMemo(() => ['UK', 'ON', 'CO', 'X1', 'LT', 'ES'], []);
  const isInfiniteAutoPlayEnabled = useConfigSlice.isInfiniteAutoPlayEnabled();
  const jurisdiction = useConfigSlice.playerConfig()?.jurisdiction ?? '';

  return useMemo(() => {
    if (EXCEPTION_JURISDICTIONS.includes(jurisdiction)) {
      return true;
    }
    return !isInfiniteAutoPlayEnabled;
  }, [EXCEPTION_JURISDICTIONS, isInfiniteAutoPlayEnabled, jurisdiction]);
};
